import {
  IBlockedBookingAvailabilitySettingPayload,
  IBlockedBookingAvailabilitySettingResponse,
  IClinicListResponse,
  ICreateAvailabilitySettingPayload,
  ICreateUpdateAvailabilitySettingResponse,
  IDeleteAvailabilitySettingResponse,
  IGetAvailabilitySettingResponse,
  IUpdateAvailabilitySettingPayload,
} from "@/models/ApiRequestResponse/doctor";

import { GBSCError } from "@/models/GBSCError";

import { deleteMethod, get, patch, post } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "@/utils/apis/APIEndpointConfig";

export const getClinicListApi = async (): Promise<
  IClinicListResponse | GBSCError
> => {
  try {
    const response = await get<IClinicListResponse>(
      APIEndpoint.doctor.clinicList
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const createAvailabilitySettingApi = async (
  requestBody: ICreateAvailabilitySettingPayload
): Promise<ICreateUpdateAvailabilitySettingResponse | GBSCError> => {
  try {
    const response = await post<ICreateUpdateAvailabilitySettingResponse>(
      APIEndpoint.doctor.availabilitySetting,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getAvailabilitySettingListingApi = async ({
  day,
  start,
  end,
}: {
  day?: string;
  start?: string;
  end?: string;
}): Promise<IGetAvailabilitySettingResponse | GBSCError> => {
  try {
    let url = `${APIEndpoint.doctor.availabilitySetting}${
      day ? `?day=${day}` : ""
    }${start ? `${day ? "&" : "?"}start=${start}` : ""}${
      end ? `${day || start ? "&" : "?"}end=${end}` : ""
    }`;
    const response = await get<IGetAvailabilitySettingResponse>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const updateAvailabilitySettingApi = async (
  requestBody: IUpdateAvailabilitySettingPayload,
  availabilitySettingId: string
): Promise<ICreateUpdateAvailabilitySettingResponse | GBSCError> => {
  try {
    const response = await patch<ICreateUpdateAvailabilitySettingResponse>(
      `${APIEndpoint.doctor.availabilitySetting}/${availabilitySettingId}`,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const deleteAvailabilitySettingApi = async (
  availabilitySettingId: string
): Promise<IDeleteAvailabilitySettingResponse | GBSCError> => {
  try {
    const response = await deleteMethod<IDeleteAvailabilitySettingResponse>(
      `${APIEndpoint.doctor.availabilitySetting}/${availabilitySettingId}`
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const blockedBookingAvailabilitySettingApi = async (
  requestBody: IBlockedBookingAvailabilitySettingPayload,
  availabilitySettingId: string
): Promise<IBlockedBookingAvailabilitySettingResponse | GBSCError> => {
  try {
    const response = await patch<IBlockedBookingAvailabilitySettingResponse>(
      `${APIEndpoint.doctor.availabilitySetting}/${availabilitySettingId}/block-booking`,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
